<script setup lang="ts">
import { defineProps, withDefaults } from 'vue';

const props = withDefaults(defineProps<{rotate: boolean, vertical: boolean}>(), {rotate: false, vertical: false})
</script>

<template>
    <svg class="w-6 h-6" :class="{'rotate-180': props.rotate && !props.vertical, '-rotate-90': props.rotate && props.vertical}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.8 3.5C16.4 3.1 15.8 3.1 15.4 3.5L6.9 12L15.4 20.5C15.8 20.9 16.4 20.9 16.8 20.5C17.2 20.1 17.2 19.5 16.8 19.1L9.7 12L16.8 4.9C17.2 4.5 17.2 3.9 16.8 3.5Z" fill="currentColor"/>
    </svg>
</template>

<style scoped>

</style>
